module.exports = __webpack_public_path__ + "static/img/boxTool-Design.f62ca5c.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/boxTool-Design.svg
// module id = dJ3V
// module chunks = 4